import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
import Partners from '@/views/Dashboard/AgencyProfiles/Partners';
import UserAccount from '@/views/Dashboard/UserAccount';
import UserAccountNameForm from '@/components/Dashboard/UserAccountNameForm';
import UserAccountPasswordForm from '@/components/Dashboard/UserAccountPasswordForm';
import UserAccountApiForm from '@/components/Dashboard/UserAccountApiForm';
import UserAccountTeamList from '@/components/Dashboard/UserAccountTeamList';
import UserAccountTeamInvite from '@/components/Dashboard/UserAccountTeamInvite';
import CreatePartnerFromInvite from '@/components/Dashboard/CreatePartnerFromInvite';
import CreateTechPartnerFromGetListed from '@/components/Dashboard/CreateTechPartnerFromGetListed';
import CreatePartnerFromGetListed from '@/components/Dashboard/CreatePartnerFromGetListed';
import { agencyProfilesRoutes } from './agencyProfiles';
import { contactRequestsRoutes } from './contactRequests';
import { integrationPartnersRoutes } from './integrationPartners';
import { matchmakingRequestRoutes } from './matchmakingRequest';
import { ourPublicProfilesRoutes } from './ourPublicProfiles';
import { reviewsRoutes } from './reviews';
import { settingsRoutes } from './settings';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Partners,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/account',
      name: 'account',
      component: UserAccount,
      children: [
        {
          path: '',
          component: UserAccountNameForm,
        },
        {
          path: 'name',
          component: UserAccountNameForm,
        },
        {
          path: 'password',
          components: {
            password: UserAccountPasswordForm,
          },
        },
        {
          path: 'api',
          components: {
            api: UserAccountApiForm,
          },
        },
      ],
    },
    {
      path: '/account/team',
      component: UserAccountTeamList,
    },
    {
      path: '/account/team/invite',
      component: UserAccountTeamInvite,
    },
    {
      path: '/create_partner/:inviteId/:companyId/:companyName/:companyType',
      name: 'createpartnershipfrominvitation',
      component: CreatePartnerFromInvite,
    },
    {
      path: '/vendor/get-listed/:directoryId/:vendorName',
      name: 'CreatePartnerFromGetListed',
      component: CreatePartnerFromGetListed,
    },
    {
      path: '/tech-partner/get-listed/:directoryId/:agencyName',
      name: 'CreatePartnerFromGetListed',
      component: CreateTechPartnerFromGetListed,
    },
    ...agencyProfilesRoutes,
    ...contactRequestsRoutes,
    ...integrationPartnersRoutes,
    ...matchmakingRequestRoutes,
    ...ourPublicProfilesRoutes,
    ...reviewsRoutes,
    ...settingsRoutes,
    {
      path: '*',
      redirect: '/',
    },
  ],
});
